import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  inputFields,
  university,
  Spacer,
  upload,
  popover,
  Buttons,
} from "../../components";

import { UniversityAction } from "../../store/actions";

const General = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const id = location.pathname.split("/")[3];

  const { universityAdmin } = useSelector((state) => state?.university);
  const { countries, otherValues } = useSelector((state) => state?.others);

  const countriesFiltered = countries?.map((country) => ({
    label: country?.name,
    value: country?.id,
  }));
  const typesFiltered = otherValues?.type?.map((item) => ({
    label: item?.type,
    value: item?.id,
  }));
  const halalFoodFiltered = otherValues?.halalFoods?.map((halal) => ({
    label: halal?.halalFoodOption,
    value: halal?.id,
  }));
  const locationTypeFiltered = otherValues?.locationType?.map((location) => ({
    label: location?.locationType,
    value: location?.id,
  }));

  const [state, setState] = useState({
    name: "",
    countryID: "",
    profilePic: "",
    campusPic: "",
    aboutUs: "",
    phone: "",
    email: "",
    website: "",
    address: "",
    courseLink: "",
    appLink: "",
    city: "",
    state: "",
    type: "",
    locationType: "",
    cityType: "",
    totalUgStudents: "",
    avgClassSize: "",
    researchOutput: "",
    acceptanceRate: "",
    facultyToStudentRatio: "",
    maleToFemaleRatio: "",
    scholAvail: "",
    avgFeesUSD: "",
    courseDuration: "",
    freshGradSalary: "",
    placementRate: "",
    facilitiesLink: "",
    halalOptions: "",
    trainDistance: "",
    busDistance: "",
    exchangeAvail: "",
    exchangeLink: "",
    percStudentsReceivingAid: "",
    avgFinancialAid: "",
    status: "",
  });
  useEffect(() => {
    setState({
      name: universityAdmin?.general?.name,
      countryID: universityAdmin?.general?.countryID,
      profilePic: universityAdmin?.general?.profilePic,
      campusPic: universityAdmin?.general?.campusPic,
      aboutUs: universityAdmin?.general?.aboutUs,
      phone: universityAdmin?.general?.phone,
      email: universityAdmin?.general?.email,
      website: universityAdmin?.general?.website,
      address: universityAdmin?.general?.address,
      courseLink: universityAdmin?.general?.courseLink,
      appLink: universityAdmin?.general?.appLink,
      city: universityAdmin?.general?.city,
      state: universityAdmin?.general?.state,
      type: universityAdmin?.general?.type,
      locationType: universityAdmin?.general?.locationType,
      cityType: universityAdmin?.general?.cityType,
      totalUgStudents: universityAdmin?.general?.totalUgStudents,
      avgClassSize: universityAdmin?.general?.avgClassSize,
      researchOutput: universityAdmin?.general?.researchOutput,
      acceptanceRate: universityAdmin?.general?.acceptanceRate,
      facultyToStudentRatio: universityAdmin?.general?.facultyToStudentRatio,
      maleToFemaleRatio: universityAdmin?.general?.maleToFemaleRatio,
      scholAvail: universityAdmin?.general?.scholAvail,
      avgFeesUSD: universityAdmin?.general?.avgFeesUSD,
      courseDuration: universityAdmin?.general?.courseDuration,
      freshGradSalary: universityAdmin?.general?.freshGradSalary,
      placementRate: universityAdmin?.general?.placementRate,
      facilitiesLink: universityAdmin?.general?.facilitiesLink,
      halalOptions: universityAdmin?.general?.halalOptions,
      trainDistance: universityAdmin?.general?.trainDistance,
      busDistance: universityAdmin?.general?.busDistance,
      exchangeAvail: universityAdmin?.general?.exchangeAvail,
      exchangeLink: universityAdmin?.general?.exchangeLink,
      percStudentsReceivingAid:
        universityAdmin?.general?.percStudentsReceivingAid,
      avgFinancialAid: universityAdmin?.general?.avgFinancialAid,
      status: universityAdmin?.general?.status,
    });
  }, [universityAdmin]);

  const handleSubmit = () => {
    const payload = {
      page: "general",
      id: parseInt(id),
      data: state,
    };

    dispatch(
      UniversityAction.editUniversity(payload, () => {
        dispatch(UniversityAction.getUniversityDetailsAdmin(id));
      })
    );
  };

  return (
    <>
      <div className="grid grid-cols-2 gap-5">
        <div>
          <university.UniInputLabel title="Name" required={true} />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.name}
            onChange={(e) => {
              setState({ ...state, name: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Country" required={true} />
          <Spacer height={10} />
          <inputFields.SelectDropdown
            items={countriesFiltered}
            value={state?.countryID}
            onChange={(e) => {
              setState({ ...state, countryID: e });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="City" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.city}
            onChange={(e) => {
              setState({ ...state, city: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="State" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.state}
            onChange={(e) => {
              setState({ ...state, state: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Profile picture" required={true} />
          <Spacer height={10} />
          <popover.WhitePopover
            content={<img src={state?.profilePic} className="h-[5em] w-full" />}
            trigger="hover"
            placement="top"
          >
            <div>
              <upload.DefaultFileUpload
                onChange={(file) => setState({ ...state, profilePic: file })}
                value={state.profilePic}
                type="image"
                showcrop
              />
            </div>
          </popover.WhitePopover>
        </div>

        <div>
          <university.UniInputLabel title="Campus photo" />
          <Spacer height={10} />
          <popover.WhitePopover
            content={<img src={state?.campusPic} className="h-[5em] w-full" />}
            trigger="hover"
            placement="top"
          >
            <div>
              <upload.DefaultFileUpload
                onChange={(file) => setState({ ...state, campusPic: file })}
                value={state.campusPic}
                type="image"
              />
            </div>
          </popover.WhitePopover>
        </div>
        <div>
          <university.UniInputLabel title="Phone Number" required={true} />
          <Spacer height={10} />
          <inputFields.DefaultPhoneInput
            value={state?.phone}
            onChange={(e) => {
              setState({ ...state, phone: e });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Email" required={true} />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.email}
            type="email"
            onChange={(e) => {
              setState({ ...state, email: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="About us" required={true} />
          <Spacer height={10} />
          <inputFields.DefaultTextbox
            value={state?.aboutUs}
            onChange={(e) => {
              setState({ ...state, aboutUs: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Address" required={true} />
          <Spacer height={10} />
          <inputFields.DefaultTextbox
            value={state?.address}
            onChange={(e) => {
              setState({ ...state, address: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Website" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.website}
            onChange={(e) => {
              setState({ ...state, website: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Course link" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.courseLink}
            onChange={(e) => {
              setState({ ...state, courseLink: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Application link" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.appLink}
            onChange={(e) => {
              setState({ ...state, appLink: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Type" required={true} />
          <Spacer height={10} />
          <inputFields.SelectDropdown
            items={typesFiltered}
            value={state?.type}
            onChange={(e) => {
              setState({ ...state, type: e });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Location Type" required={true} />
          <Spacer height={10} />
          <inputFields.SelectDropdown
            items={locationTypeFiltered}
            value={state?.locationType}
            onChange={(e) => {
              setState({ ...state, locationType: e });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Total UG students" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.totalUgStudents}
            onChange={(e) => {
              setState({ ...state, totalUgStudents: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Avergae class size" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.avgClassSize}
            onChange={(e) => {
              setState({ ...state, avgClassSize: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Research output" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.researchOutput}
            onChange={(e) => {
              setState({ ...state, researchOutput: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Acceptance rate" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.acceptanceRate}
            onChange={(e) => {
              setState({ ...state, acceptanceRate: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Faculty to student ratio" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.facultyToStudentRatio}
            onChange={(e) => {
              setState({ ...state, facultyToStudentRatio: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Male to female ratio" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.maleToFemaleRatio}
            onChange={(e) => {
              setState({ ...state, maleToFemaleRatio: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Scholarship availibility" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.scholAvail}
            type="number"
            onChange={(e) => {
              setState({ ...state, scholAvail: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Average fees (USD)" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.avgFeesUSD}
            type="number"
            onChange={(e) => {
              setState({ ...state, avgFeesUSD: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Course duration" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.courseDuration}
            onChange={(e) => {
              setState({ ...state, courseDuration: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Fresh grad salary" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.freshGradSalary}
            type="number"
            onChange={(e) => {
              setState({ ...state, freshGradSalary: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Placement rate" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.placementRate}
            type="number"
            onChange={(e) => {
              setState({ ...state, placementRate: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Facilities link" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.facilitiesLink}
            onChange={(e) => {
              setState({ ...state, facilitiesLink: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Halal food availibility" />
          <Spacer height={10} />
          <inputFields.SelectDropdown
            items={halalFoodFiltered}
            value={state?.halalOptions}
            onChange={(e) => {
              setState({ ...state, halalOptions: e });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Train distance" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.trainDistance}
            onChange={(e) => {
              setState({ ...state, trainDistance: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Bus distance" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.busDistance}
            onChange={(e) => {
              setState({ ...state, busDistance: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Exchange availibility" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.exchangeAvail}
            type="number"
            onChange={(e) => {
              setState({ ...state, exchangeAvail: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Exchange link" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.exchangeLink}
            onChange={(e) => {
              setState({ ...state, exchangeLink: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="% students receiving aid" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.percStudentsReceivingAid}
            onChange={(e) => {
              setState({ ...state, percStudentsReceivingAid: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Average financial aid" />
          <Spacer height={10} />
          <inputFields.DefaultInput
            value={state?.avgFinancialAid}
            onChange={(e) => {
              setState({ ...state, avgFinancialAid: e.target.value });
            }}
          />
        </div>
        <div>
          <university.UniInputLabel title="Status" />
          <Spacer height={10} />
          <inputFields.SelectDropdown
            items={[
              { label: "Accepted", value: "accepted" },
              { label: "Rejected", value: "rejected" },
              { label: "Pending", value: "pending" },
            ]}
            value={state?.status}
            onChange={(e) => {
              setState({ ...state, status: e });
            }}
          />
        </div>
      </div>
      <Spacer height={20} />
      <div className="w-full flex justify-end">
        <Buttons.DefaultButton onClick={handleSubmit}>
          Save Changes
        </Buttons.DefaultButton>
      </div>
      <Spacer height={60} />
    </>
  );
};

export default General;
